import { jsx as r } from "react/jsx-runtime";
import { c as e } from "../../../clsx-OuTLNxxd.js";
const a = "_container_68o99_29", s = {
  container: a,
  "is-fluid": "_is-fluid_68o99_50"
};
function _({ isFluid: n = !1, children: o, className: i = "", ...t }) {
  const c = e(s.container, n && s["is-fluid"], i);
  return /* @__PURE__ */ r("div", { className: c, ...t, children: o });
}
export {
  _ as Container
};
